<template>
  <b-overlay :show="fetching">
    <div class="d-flex justify-content-end">
      <b-button
        v-b-modal.create-edit-country
        variant="outline-primary"
      >
        <feather-icon icon="PlusIcon" />  Create Country
      </b-button>
    </div>
    <h5>Country</h5>
    <b-card no-body>
      <b-table
        :fields="columns"
        :items="tableRows"
      >
        <template #cell(actions)="data">
          <b-button
            v-b-modal.create-edit-country
            variant="outline-secondary"
            class="p-1"
            @click="selectCountry(data.item)"
          >
            <feather-icon
              icon="EditIcon"
            />
          </b-button>
        </template>
      </b-table>
    </b-card>

    <!-- Modal -->
    <b-modal
      id="create-edit-country"
      :title="mode === 'edit' ? 'Edit Country' : 'Create Country'"
      @hidden="closeModal"
    >
      <validation-observer ref="simpleRules">
        <b-row
          v-for="(input, index) of inputs"
          :key="index"
          class="mb-1"
        >
          <b-col cols="6">
            <b-form-group label="Country Name">
              <validation-provider
                #default="{ errors }"
                name="country name"
                rules="required"
                :vid="`country-name-${index}`"
              >
                <b-form-input
                  v-model="input.name"
                  placeholder="Country Name"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="5">
            <b-form-group label="Code">
              <validation-provider
                #default="{ errors }"
                name="country code"
                rules="required"
                :vid="`country-code-${index}`"
              >
                <b-form-input
                  v-model="input.code"
                  placeholder="Country code"
                  :disabled="mode === 'edit'"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            v-if="index > 0"
            cols="1"
          >
            <feather-icon
              v-b-tooltip.hover="'Remove Country'"
              icon="TrashIcon"
              class="text-danger"
              role="button"
              @click="removeMore(index)"
            />
          </b-col>
        </b-row>
        <b-button
          v-if="mode === 'create'"
          variant="outline-primary"
          @click="addMore"
        >
          <feather-icon icon="PlusIcon" /> Add Country
        </b-button>
      </validation-observer>
      <template #modal-footer="{}">
        <b-row>
          <b-col
            md="12"
            class="d-flex justify-content-end"
          >
            <b-button
              @click="() => $bvModal.hide('create-edit-country')"
            >
              Cancel
            </b-button>
            <b-button
              variant="primary"
              class="ml-2"
              :disabled="processing"
              @click="handleConfirm"
            >
              <b-spinner
                v-show="processing"
                small
              />
              Confirm
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>
  </b-overlay>
</template>
<script>
import {
  BButton,
  BModal,
  BFormInput,
  BSpinner,
  BFormGroup,
  BTable,
  BCard,
  BOverlay,
  VBTooltip,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import useApollo from '@/plugins/graphql/useApollo'

export default {
  components: {
    BButton,
    BModal,
    BFormInput,
    ValidationProvider,
    ValidationObserver,
    BSpinner,
    BFormGroup,
    BTable,
    BCard,
    BOverlay,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  data() {
    return {
      processing: false,
      required,
      inputs: [
        {
          name: '',
          code: '',
        },
      ],
      columns: [
        { key: 'name', text: 'Name' },
        { key: 'code', text: 'Code' },
        { key: 'actions', text: 'Actions' },
      ],
      fetching: true,
      tableRows: [],
      mode: 'create',
      selectedCountry: {},
    }
  },
  mounted() {
    this.fetchCountries()
  },
  methods: {
    selectCountry(item) {
      this.mode = 'edit'
      this.inputs = [
        { name: item.name, code: item.code },
      ]
    },
    addMore() {
      this.inputs.push({
        name: '',
        code: '',
      })
    },
    fetchCountries() {
      this.fetching = true
      useApollo.jobs
        .getCountries()
        .then(response => {
          this.tableRows = response.data.countries.data
        })
        .catch(error => {
          this.showErrorMessage(error)
        })
        .finally(() => {
          this.fetching = false
        })
    },
    removeMore(index) {
      this.inputs.splice(index, 1)
    },
    handleConfirm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.processing = true
          useApollo.jobs
            .addCountries(this.inputs)
            .then(response => {
              this.fetchCountries()
              this.$bvModal.hide('create-edit-country')
              if (this.mode === 'create') this.showSuccess(response?.data?.registerCountries?.message)
              else this.showSuccess('Country has been updated successfully')
            })
            .catch(error => {
              this.showErrorMessage(error)
            })
            .finally(() => {
              this.processing = false
            })
        }
      })
    },
    closeModal() {
      this.mode = 'create'
      this.inputs = [
        {
          name: '',
          code: '',
        },
      ]
    },
  },
}
</script>
